module.exports = __webpack_public_path__ + "static/christian.8918dad2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/graphics/contributors/christian.jpg
// module id = ./src/assets/graphics/contributors/christian.jpg
// module chunks = 1